import { useContext } from 'react';

import { AuthContext } from '../contexts/AuthContext/AuthContext';
import { IUserAuth } from '../contexts/reducer/userAuthReducer';

const useAuth = (): IUserAuth => useContext(AuthContext);

export default useAuth;
